import React from 'react';
import * as XLSX from 'xlsx';

const ExcelViewer = ({ base64 }: { base64: string }) => {
    const [data, setData] = React.useState<any[][]>([]);

    React.useEffect(() => {
        const binaryString = atob(base64);
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });
        setData(sheetData as any[][]);
    }, [base64]);

    return (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
                {data.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                        {row.map((cell, cellIndex) => (
                            <td
                                key={cellIndex}
                                style={{
                                    border: '1px solid #ddd',
                                    padding: '8px',
                                }}
                            >
                                {cell}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default ExcelViewer;
